import React from 'react';

const PageHeader = () => (
  <p className="header">
    KEVIN RANDLES
  </p>
);

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js